/* eslint-disable */
import React, { useState, useEffect } from 'react';
import { useStore } from '../../store/store';
import { MultiCheck } from '../../components/ui/multi-check/MultiCheck';
import { MultiOption } from '../../components/ui/multi-check/Option';
import { useNav } from '../../hooks/nav';
import { ReactComponent as BackIcon } from '../../assets/images/arrowLeft.svg';
import Analytics from '@web-solutions/module-analytics';
import { t } from '@web-solutions/module-localization';
import Button from 'src/onboarding/components/ui/button/Button';
import { Title } from 'src/onboarding/components/typography/Title/Title';

function Page() {
  const sideEffects = useStore((state) => state.sideEffects);
  const setSideEffects = useStore((state) => state.setSideEffects);
  const [next, setNext] = useState(sideEffects.length > 0);
  const { onNext, onPrev, currentIndex } = useNav();

  useEffect(() => {
    if (sideEffects.length >= 2 && sideEffects.includes('None of the above')) {
      setNext(false);
    }
  }, []);

  const handleChange = (value) => {
    if (value.includes('None of the above')) {
      if (value.length === 1) {
        setNext(true);
        onNext();
      } else {
        setNext(false);
        return;
      }
      setNext(false);
    }
    setSideEffects(value);
    setNext(value.length > 0);
  };

  return (
    <div className={'page'}>
      {currentIndex !== 0 && (
        <div className={'back'} onClick={onPrev}>
          <BackIcon />
        </div>
      )}
      <div className={'wrapper-info'}>
        <Title tag='h2'>{t('onboarding.sideEffects.title')}</Title>
      </div>

      <div className={'controls'} style={{ marginBottom: 70 }}>
        <MultiCheck defaultValue={sideEffects} onChange={handleChange}>
          <MultiOption value={'Nausea'}>{t('onboarding.sideEffects.options.nausea')}</MultiOption>
          <MultiOption value={'Vomiting'}>
            {t('onboarding.sideEffects.options.vomiting')}
          </MultiOption>
          <MultiOption value={'Diarrhea'}>
            {t('onboarding.sideEffects.options.diarrhea')}
          </MultiOption>
          <MultiOption value={'Constipation'}>
            {t('onboarding.sideEffects.options.constipation')}
          </MultiOption>
          <MultiOption value={'Bloating or gas'}>
            {t('onboarding.sideEffects.options.bloating')}
          </MultiOption>
          <MultiOption value={'Fatigue'}>{t('onboarding.sideEffects.options.fatigue')}</MultiOption>
          <MultiOption value={'Headache'}>
            {t('onboarding.sideEffects.options.headache')}
          </MultiOption>
          <MultiOption value={'Dizziness'}>
            {t('onboarding.sideEffects.options.dizziness')}
          </MultiOption>
          <MultiOption value={'None of the above'}>
            {t('onboarding.sideEffects.options.none')}
          </MultiOption>
        </MultiCheck>
        <div className={'overlay'}></div>
      </div>

      <div className={'next-wrapper'}>
        <Button
          className={next ? '' : 'disabled'}
          title={t('onboarding.sideEffects.continue')}
          onClick={() => {
            if (!next) return;
            Analytics.trackEvent(`step${currentIndex + 1}`, 'complete', {
              page: 'side-effects',
              answer: sideEffects.join(', '),
            });
            onNext();
          }}
        />
      </div>
    </div>
  );
}
export default Page;
